import { GLOBAL_API_ERROR_CODES } from '@data/global-api-errors';
import type { GlobalApiErrorCode } from '@data/global-api-errors';

import { CANCELLATION_REASONS } from '../../global.constants';
import type { CancellationReason } from '../../global.types';

export const VERIFICATION_VIEW_NAME = 'Verification view';
export const VERIFICATION_VIEW_CODE_DISABLED_REASON_ID =
  'verification-view-code-disabled-reason';

export const VERIFICATION_VIEW_CANCELLATION_REASONS = [
  CANCELLATION_REASONS.didNotReceiveTheCode,
  CANCELLATION_REASONS.codeIsNotWorking,
  CANCELLATION_REASONS.doNotHaveMyDeviceAtHand,
  CANCELLATION_REASONS.other,
] satisfies CancellationReason[];

export const HANDLED_ERRORS: GlobalApiErrorCode[] = [
  GLOBAL_API_ERROR_CODES.CODE_424.UNAUTHORISED,
];

export const EMPTY_CHALLANGE_DATA = {
  data: undefined,
  type: undefined,
} as const;
